import { render, staticRenderFns } from "./ElementsMenu.vue?vue&type=template&id=2908dd10"
import script from "./ElementsMenu.vue?vue&type=script&lang=js"
export * from "./ElementsMenu.vue?vue&type=script&lang=js"
import style0 from "./ElementsMenu.vue?vue&type=style&index=0&id=2908dd10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports